<template>
  <el-dialog :visible="visible" :width="dialogWidth" :before-close="this.befclose" title="选择产品">
    <div class="select-product">
      <div class="left-content">
        <el-input class="input" prefix-icon="el-icon-search" size="small" v-model="keywords" @keyup.enter.native="handleSearch" />
        <div class="select-wrap">
          <span class="label">选择产品线</span>
          <el-select class="select" size="small" v-model="selectedProductLine" @change="handleProductLineChange">
            <el-option value="" label="全部领域">全部领域</el-option>
            <el-option
              v-for="productLine in productLines"
              :key="productLine.id"
              :value="productLine.id"
              :label="`${productLine.id}-${productLine.name}`"
            >
              {{productLine.id}}-{{productLine.name}}
            </el-option>
          </el-select>
        </div>
		<div class="choose-all" v-if="!isAllCheck">
        	<el-checkbox v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
		</div>
		<div class="choose-scroll" style="height:500px">
			<el-checkbox-group v-model="checkList" @change="handleCheckboxChange" style="height:100%">
				<ul class="product-list">
					<li class="product" v-for="product in products" :key="product.id">
					<el-checkbox :key="product.id" :label="product.id" :value="product.id" @change="checked=>searchProductChange(checked, product)">
						<div class="row">
						<div class="image-wrap">
							<img :src="product.logoMainArr && product.logoMainArr[0]" width="60" />
						</div>
						<div class="main">
							<div class="product-title">{{product.name}}|{{product.commonName}}</div>
							<div class="product-desc">
							{{product.commonPack}}:{{product.commonSpec}}
							<span v-if="product.minPackSpec"> | </span>
							{{product.minPackSpec}}</div>
							<div class="product-desc">
							{{product.productLineName}}
							<span v-if="product.materialCode"> | </span>
							{{product.materialCode}}
							</div>
						</div>
						</div>
					</el-checkbox>
					</li>
				</ul>
			</el-checkbox-group>
		</div>
      </div>
      <div class="right-content" v-if="infinite">
        <div class="bm bm-pj">
            <span class="tip">当前页已选:<span style="color:#2D7FD5"> {{this.selects.length}} </span>项产品</span>
            <span class="tip">总共已选择:<span style="color:#2D7FD5"> {{this.checkList.length}} </span>项产品</span>
        </div>
        <ul class="selected-products">
          <li v-for="select in selects" :key="select.id" class="selected-product">
            <div class="product-title">
              {{select.name}}
              <span v-if="select.commonName"> | </span>
              {{select.commonName}}
            </div>
            <div class="product-desc">
              {{select.commonPack}}:{{select.commonSpec}}
              <span v-if="select.minPackSpec"> | </span>
              {{select.minPackSpec}}</div>
            <div class="product-desc">
              {{select.productLineName}}
              <span v-if="select.materialCode"> | </span>
              {{select.materialCode}}
            </div>
            <i class="icon el-icon-close" @click="handleUnselect(select.id)" />
          </li>
        </ul>
        <div class="actions">
          <el-button @click="handleCancel" size="small">取消</el-button>
          <el-button @click="handleConfirm" size="small" type="primary">确定</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
	props: {
		visible: {
			type: Boolean,
			required: true
		},
		productLines: {
			type: Array,
			required: true
		},
		infinite: {
			type: Boolean,
			default: true
		},
		//产品列表
		products: {
			type: Array,
			required: true
		},
		selectedProducts: {
			type: Array,
			default() {
				return []
			}
		}
	},
	data() {
		return {
			checkList: [],
			checkAll: false,
			selectedProductLine: "",
			keywords: "",
			leftBoxHeight: 0,
			rightBoxHeight: 0,
			searchBoxHeight: 0,
		}
	},
	computed: {
		selects() {
			return this.products.filter((product) =>{
				return this.checkList.includes(product.id)
			})
		},
		dialogWidth () {
			if (this.infinite) {
				return 886 + "px";
			} else {
				return 886 / 2 + "px";
			}
		},
		isAllCheck () {
			if (this.infinite) {
				return false;
			} else {
				return true;
			}
		}
	},
	watch: {
		selectedProducts: {
			handler: function(newValue, oldValue) {
				if( this.infinite ){
					if (newValue !== oldValue) {
						const checkedProductIds = newValue.map((item) => {
							return item.id
						})
						this.checkList = [ ...this.checkList, ...checkedProductIds]
						console.log("已选的数据1",this.checkList);
					}
				}else{
					const checkedProductIds = newValue.map((item) => {
						return item.id
					})
					this.checkList = checkedProductIds
				}
				
			},
			immediate: true,
			deep: true
        },
        visible() {
            let flag = this.visible;
            let selectedProducts = this.selectedProducts;
            if (flag) {
                if (selectedProducts.length === 0) {
                    this.checkList.splice(0, this.checkList.length);
                    this.keywords = '';
                    this.selectedProductLine = "";
                }
            }
        }
	},
	methods: {
		handleCheckAllChange(value) {
			if (value) {
				this.checkList = this.products.map((product) => {
					return product.id
				})
			} else {
				this.checkList = []
			}
		},
		handleCheckboxChange(value) {
			if (value.length === this.products.length) {
				this.checkAll = true
			}
		},
		handleUnselect(productId) {
			this.checkList.splice(this.checkList.indexOf(productId), 1)
		},
		handleProductLineChange() {
			this.handleSearch()
		},
		handleKeywordsChange() {
			this.handleSearch()
		},
		handleSearch() {
			const { selectedProductLine, keywords } = this
			this.$emit("search", { productLine: selectedProductLine, keywords })
		},
		handleCancel() {
			this.$emit("cancel")
		},
		handleConfirm() {
			this.$emit("confirm", this.selects)
			console.log("this.selects", this.selects)
		},
		befclose() {
			this.$emit("befclose");
		},
		setHeight () {
			let windowHeight = document.documentElement.clientHeight;
			let wheight1 = windowHeight / 2 - 60;
			let wheight2 = windowHeight / 2 - 20;
			let wheight3 = windowHeight / 2 + 55;
			this.leftBoxHeight = wheight1;
			this.rightBoxHeight = wheight2;
			if (this.infinite) {
				this.searchBoxHeight = wheight3;
			} else {
				this.searchBoxHeight = wheight3 - 67;
			}

			window.onresize = () => {
				this.setHeight();
			};
		},
		searchProductChange(){
			
		},
		searchProductChange (checked, value) {
			console.log(checked,value);
			console.log(this.selects)
			let checkedProduct = [value]
			this.$emit("confirm", checkedProduct)
			// if (this.infinite) {
			// 	this.$emit("confirm", this.selects)
			// } else {
			// 	this.$emit("confirm", this.selects)
			// }
		},
	},
	mounted () {
		this.setHeight();
	},
}
</script>
<style lang="scss" scoped>
.el-dialog__wrapper {
	/deep/.el-dialog__header {
		border-bottom: 1px solid #dcdfe5;
	}
	/deep/.el-dialog__body {
		padding-top: 10px;
	}
	.select-product {
		display: flex;
		flex-direction: row;
		.left-content {
			width: 400px;
			//   padding: 10px 20px 20px;
			padding: 0;
			height: 500px;
			overflow: hidden;
			.select-wrap {
				margin-top: 10px;
				margin-bottom: 10px;
				display: flex;
				flex-direction: row;
				align-items: center;
				.label {
					flex-basis: 76px;
					font-size: 12px;
					color: #323232;
					margin-right: 10px;
				}
				.select {
					flex: auto;
					width: 100%;
				}
			}
			.choose-scroll{
				height: 500px;
				/deep/.el-checkbox-group{
					.product-list {
						padding: 0;
						margin-top: 20px;
						height: 100%;
						overflow: auto;
						.product {
							.el-checkbox {
								display: flex;
								align-items: center;
							}
							.row {
								display: flex;
								flex-direction: row;
								align-items: center;
								padding: 15px 0;
								.image-wrap {
									width: 60px;
									height: auto;
								}
								.main {
									margin-left: 10px;
									.product-title {
										font-size: 14px;
										color: #646464;
										line-height: 18px;
										font-weight: normal;
									}
									.product-desc {
										font-size: 12px;
										color: #969696;
										line-height: 25px;
									}
								}
							}
						}
					}
				}
			}
		}
		.right-content {
			width: 400px;
			padding: 10px 20px 20px;
			border-left: 1px solid #dcdfe5;
			.tip {
				font-size: 14px;
				color: #969696;
				line-height: 18px;
				margin-bottom: 10px;
			}
			.selected-products {
				padding: 0;
				margin: 0;
				height: 420px;
				overflow: auto;
				.selected-product {
					list-style: none;
					padding: 8px 10px;
					background-color: #f0f2f5;
					margin-top: 10px;
					border-radius: 4px;
					position: relative;
					.product-title {
						font-size: 14px;
						color: #646464;
						line-height: 18px;
						font-weight: normal;
					}
					.product-desc {
						font-size: 12px;
						color: #969696;
						line-height: 25px;
					}
					.icon {
						position: absolute;
						right: 4px;
						top: 4px;
						padding: 6px;
						cursor: pointer;
					}
				}
			}
			.actions {
				margin-top: 20px;
				text-align: right;
			}
		}
	}
}
</style>
